import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export const BlockActionButton = ({
  disabled = false,
  children,
  ...rest
}: ComponentPropsWithoutRef<"button">) => (
  <button
    {...rest}
    type="button"
    disabled={disabled}
    className={classNames(
      "flex size-6 cursor-pointer items-center justify-center rounded-[0.25rem] text-white transition-colors hover:bg-white/10",
      "focus-visible:outline-primary focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
      {
        "cursor-not-allowed opacity-50": disabled,
      },
    )}
  >
    {children}
  </button>
);
